module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_8023.8de08600.png";